import { atom } from "jotai";
import { AssetType } from "../types";
import { capitalizedAssetTypeDisplayAtom } from "../utils/capitalizedAssetDisplayNameAtom";

interface GetAssetTitleParams {
  asset: any;
  assetType: AssetType;
}

export const getAssetTitleAtom = atom((get) => {
  return ({ asset, assetType }: GetAssetTitleParams): string => {
    const getAssetDisplayName = get(capitalizedAssetTypeDisplayAtom);
    const maybeCapitalizedAssetType =
      assetType === "zap"
        ? getAssetDisplayName(assetType)
        : getAssetDisplayName(assetType).toLowerCase();
    if (!asset) return `${maybeCapitalizedAssetType}`;

    switch (assetType) {
      case "zap":
        return asset.title || `Untitled ${maybeCapitalizedAssetType}`;
      case "interface":
        return asset || `Untitled ${maybeCapitalizedAssetType}`;
      case "chatbot":
      case "table":
      case "agent":
        return asset.name || `Untitled ${maybeCapitalizedAssetType}`;
      default:
        return `${maybeCapitalizedAssetType} - ${asset.id || "Unknown"}`;
    }
  };
});
getAssetTitleAtom.debugLabel = "getAssetTitleAtom";
